"use client";

import { misc, theme, util } from "@/common/theme";
import styled from "styled-components";
import { SectionTitle } from "../../SectionTitle";
import { ScrollingText } from "../../ScrollingText";
import CustomSplitText from "@/mono/components/CustomSplitText";
import { mediaMobile } from "@/mono/lib/responsive";
import { AcronymLogo } from "components/Logo";

export function HomeWhoWeAre() {
  return (
    <>
      <SectionTitle>Who we are</SectionTitle>

      <Wrapper>
        <ScrollingText>
          9CA is een creatief reclame- en communicatiebureau. Wij creëren
          communicatie die gezien wordt, merkbeloftes waarmaakt en bedrijven
          laat groeien. Van branding t/m campagnes.
        </ScrollingText>

        <AcronymLogo />
      </Wrapper>
    </>
  );
}

const Wrapper = styled.section`
  position: relative;
  width: 100%;

  ${util.inner}

  padding-bottom: 120rem;

  .acronym-logo {
    position: absolute;
    top: calc(50% + 40rem);
    transform: translateY(-50%);
    right: ${misc.pagePadding()};
    width: 850rem;

    z-index: 0;
  }

  h3 {
    position: relative;
    z-index: 1;
  }

  .home-who-we-are__ca {
    z-index: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    /* max-width: 30%; */
    width: 100%;
    right: ${(props) => props.theme.misc.pagePadding()};

    ${mediaMobile(`
      
      z-index: -1;
    `)}

    h1 {
      color: ${({ theme }) => theme.theme.accent};
      text-align: right;
    }
  }
`;
